import { useEffect, useState } from "react";

const START_SECONDS = 17 * 60 + 34;

export function useCountdown() {
  const [seconds, setSeconds] = useState(START_SECONDS);

  useEffect(() => {
    const id = window.setInterval(() => {
      setSeconds((s) => (s <= 1 ? START_SECONDS : s - 1));
    }, 1000);
    return () => window.clearInterval(id);
  }, []);

  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  return {
    hours: String(h).padStart(2, "0"),
    minutes: String(m).padStart(2, "0"),
    seconds: String(s).padStart(2, "0"),
  };
}
